<template lang="jade">
  .container-fluid
    .row
      .port_status_main.col-md-12
        header.port_status_title_bar.main_title_bar.clearfix
            h1.title.col-md-10.col-sm-10.col-xs-12.hidden-xs Port Status
            h1.title.col-md-10.col-sm-10.col-xs-12.visible-xs Port Status
        section.port_status_content.clear-left.clearfix.row_space--xs
          table.table.table-bordered.table-striped.table-hover.port_status_table
            tr
              th Port No.
              th Type
              th Link
              th State
              th Speed / Duplex
              th Flow Control
            tr(v-for='(key, port) in ports')
              td {{port.portNo}}
              td {{port.type}}
              td {{port.link}}
              td {{port.state}}
              td {{port.speed || "N"}}/{{port.duplex || "A"}}
              td {{port.flowControl || "N/A"}}

</template>
<script>
import { call } from 'src/Service'
export default {
  components: {
  },
  data () {
    return {
      ports: {}
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    call(mac, 'dxGetPortStatus').then(({ports}) => {
      this.ports = ports
    })
  },
  computed: {
  },
  methods: {

  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
  table th {
    text-align: center;
    background-color: $pri_gray_light;
  }
  .port_status_table{
    text-align:center;
  }
  @include breakpoint(xxs) {
    .port_status_table{
      th{
        padding:3px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PortStatus.vue?40c09e87